function pointerSizedTypedefs(is64: boolean): string {
  const s = is64 ? "long long" : "int";
  const u = is64 ? "unsigned long long" : "unsigned int";
  return `
typedef ${s} INT_PTR;
typedef ${u} UINT_PTR;
typedef ${s} LONG_PTR;
typedef ${u} ULONG_PTR;
typedef ${u} SIZE_T;
typedef ${s} SSIZE_T;
typedef ${u} DWORD_PTR;
typedef ${s} LPARAM;
typedef ${u} WPARAM;
typedef ${s} LRESULT;
`;
}

const WIN32_TYPES = `
typedef unsigned char BYTE;
typedef unsigned char UCHAR;
typedef char CHAR;
typedef unsigned short WORD;
typedef unsigned short USHORT;
typedef short SHORT;
typedef unsigned short WCHAR;
typedef unsigned short ATOM;
typedef int INT;
typedef unsigned int UINT;
typedef int LONG;
typedef unsigned int ULONG;
typedef unsigned int DWORD;
typedef int BOOL;
typedef long long LONGLONG;
typedef unsigned long long ULONGLONG;
typedef unsigned long long DWORDLONG;
typedef float FLOAT;
typedef double DOUBLE;
typedef LONG HRESULT;
typedef LONG NTSTATUS;
typedef int TOKEN_INFORMATION_CLASS;
typedef void *PVOID;
typedef void *LPVOID;
typedef const void *LPCVOID;
typedef void *HANDLE;
typedef void *HWND;
typedef void *HMODULE;
typedef void *HINSTANCE;
typedef void *HHOOK;
typedef void *HMENU;
typedef void *HDC;
typedef void *HICON;
typedef void *HCURSOR;
typedef void *HBRUSH;
typedef void *HBITMAP;
typedef void *HFONT;
typedef void *HGDIOBJ;
typedef void *HKEY;
typedef void *HRGN;
typedef void *HGLOBAL;
typedef void *HLOCAL;
typedef void *HRSRC;
typedef void *HACCEL;
typedef void *HMONITOR;
typedef void *HINTERNET;
typedef void *SC_HANDLE;
typedef UINT_PTR SOCKET;
typedef void *FARPROC;
typedef void *WNDPROC;
typedef void *WNDENUMPROC;
typedef void *HOOKPROC;
typedef void *DLGPROC;
typedef void *TIMERPROC;
typedef void *PTHREAD_START_ROUTINE;
typedef void *LPSECURITY_ATTRIBUTES;
typedef void *LPOVERLAPPED;
typedef void *LPSTARTUPINFOW;
typedef void *LPSTARTUPINFOA;

typedef CHAR *LPSTR;
typedef const CHAR *LPCSTR;
typedef CHAR *PSTR;
typedef const CHAR *PCSTR;
typedef WCHAR *LPWSTR;
typedef const WCHAR *LPCWSTR;
typedef WCHAR *PWSTR;
typedef const WCHAR *PCWSTR;
typedef BYTE *LPBYTE;
typedef BYTE *PBYTE;
typedef WORD *LPWORD;
typedef DWORD *LPDWORD;
typedef DWORD *PDWORD;
typedef ULONG *PULONG;
typedef BOOL *LPBOOL;
typedef int *LPINT;
typedef UINT *LPUINT;
typedef LONG *LPLONG;
typedef HANDLE *LPHANDLE;
typedef HANDLE *PHANDLE;
typedef HKEY *PHKEY;
typedef SIZE_T *PSIZE_T;
typedef struct _POINT { LONG x; LONG y; } POINT;
typedef POINT *LPPOINT;
typedef struct _SIZE { LONG cx; LONG cy; } SIZE;
typedef SIZE *LPSIZE;
typedef struct tagRECT { LONG left; LONG top; LONG right; LONG bottom; } RECT;
typedef RECT *LPRECT;
typedef const RECT *LPCRECT;
typedef struct _MARGINS { int cxLeftWidth; int cxRightWidth; int cyTopHeight; int cyBottomHeight; } MARGINS;
typedef MARGINS *PMARGINS;
typedef struct _FILETIME { DWORD dwLowDateTime; DWORD dwHighDateTime; } FILETIME;
typedef FILETIME *LPFILETIME;
typedef struct tagMSG { HWND hwnd; UINT message; WPARAM wParam; LPARAM lParam; DWORD time; POINT pt; DWORD lPrivate; } MSG;
typedef MSG *LPMSG;
typedef struct _LUID { DWORD LowPart; LONG HighPart; } LUID;
typedef struct _PROCESS_INFORMATION { HANDLE hProcess; HANDLE hThread; DWORD dwProcessId; DWORD dwThreadId; } PROCESS_INFORMATION;
typedef PROCESS_INFORMATION *LPPROCESS_INFORMATION;
typedef void *LPPROCESSENTRY32W;
typedef void *LPPROCESSENTRY32;
typedef void *LPMODULEENTRY32W;
typedef void *LPMODULEENTRY32;
`;

const WIN32_FUNCS = `
extern HANDLE GetCurrentProcess(void);
extern HANDLE GetCurrentThread(void);
extern DWORD GetCurrentProcessId(void);
extern DWORD GetCurrentThreadId(void);
extern BOOL OpenProcessToken(HANDLE ProcessHandle, DWORD DesiredAccess, PHANDLE TokenHandle);
extern BOOL OpenThreadToken(HANDLE ThreadHandle, DWORD DesiredAccess, BOOL OpenAsSelf, PHANDLE TokenHandle);
extern BOOL GetTokenInformation(HANDLE TokenHandle, TOKEN_INFORMATION_CLASS TokenInformationClass, LPVOID TokenInformation, DWORD TokenInformationLength, PDWORD ReturnLength);
extern BOOL AdjustTokenPrivileges(HANDLE TokenHandle, BOOL DisableAllPrivileges, LPVOID NewState, DWORD BufferLength, LPVOID PreviousState, PDWORD ReturnLength);
extern BOOL LookupPrivilegeValueW(LPCWSTR lpSystemName, LPCWSTR lpName, LUID *lpLuid);
extern HANDLE OpenProcess(DWORD dwDesiredAccess, BOOL bInheritHandle, DWORD dwProcessId);
extern HANDLE OpenThread(DWORD dwDesiredAccess, BOOL bInheritHandle, DWORD dwThreadId);
extern BOOL TerminateProcess(HANDLE hProcess, UINT uExitCode);
extern HANDLE CreateToolhelp32Snapshot(DWORD dwFlags, DWORD th32ProcessID);
extern BOOL Process32FirstW(HANDLE hSnapshot, LPPROCESSENTRY32W lppe);
extern BOOL Process32NextW(HANDLE hSnapshot, LPPROCESSENTRY32W lppe);
extern BOOL Process32First(HANDLE hSnapshot, LPPROCESSENTRY32 lppe);
extern BOOL Process32Next(HANDLE hSnapshot, LPPROCESSENTRY32 lppe);
extern BOOL Module32FirstW(HANDLE hSnapshot, LPMODULEENTRY32W lpme);
extern BOOL Module32NextW(HANDLE hSnapshot, LPMODULEENTRY32W lpme);
extern HANDLE CreateRemoteThread(HANDLE hProcess, LPSECURITY_ATTRIBUTES lpThreadAttributes, SIZE_T dwStackSize, PTHREAD_START_ROUTINE lpStartAddress, LPVOID lpParameter, DWORD dwCreationFlags, LPDWORD lpThreadId);
extern HANDLE CreateThread(LPSECURITY_ATTRIBUTES lpThreadAttributes, SIZE_T dwStackSize, PTHREAD_START_ROUTINE lpStartAddress, LPVOID lpParameter, DWORD dwCreationFlags, LPDWORD lpThreadId);
extern BOOL ReadProcessMemory(HANDLE hProcess, LPCVOID lpBaseAddress, LPVOID lpBuffer, SIZE_T nSize, PSIZE_T lpNumberOfBytesRead);
extern BOOL WriteProcessMemory(HANDLE hProcess, LPVOID lpBaseAddress, LPCVOID lpBuffer, SIZE_T nSize, PSIZE_T lpNumberOfBytesWritten);
extern LPVOID VirtualAllocEx(HANDLE hProcess, LPVOID lpAddress, SIZE_T dwSize, DWORD flAllocationType, DWORD flProtect);
extern BOOL VirtualProtectEx(HANDLE hProcess, LPVOID lpAddress, SIZE_T dwSize, DWORD flNewProtect, PDWORD lpflOldProtect);
extern BOOL CreateProcessW(LPCWSTR lpApplicationName, LPWSTR lpCommandLine, LPSECURITY_ATTRIBUTES lpProcessAttributes, LPSECURITY_ATTRIBUTES lpThreadAttributes, BOOL bInheritHandles, DWORD dwCreationFlags, LPVOID lpEnvironment, LPCWSTR lpCurrentDirectory, LPSTARTUPINFOW lpStartupInfo, LPPROCESS_INFORMATION lpProcessInformation);
extern BOOL CreateProcessA(LPCSTR lpApplicationName, LPSTR lpCommandLine, LPSECURITY_ATTRIBUTES lpProcessAttributes, LPSECURITY_ATTRIBUTES lpThreadAttributes, BOOL bInheritHandles, DWORD dwCreationFlags, LPVOID lpEnvironment, LPCSTR lpCurrentDirectory, LPSTARTUPINFOA lpStartupInfo, LPPROCESS_INFORMATION lpProcessInformation);
extern DWORD WaitForSingleObject(HANDLE hHandle, DWORD dwMilliseconds);
extern DWORD WaitForMultipleObjects(DWORD nCount, LPHANDLE lpHandles, BOOL bWaitAll, DWORD dwMilliseconds);
extern HANDLE CreateEventW(LPSECURITY_ATTRIBUTES lpEventAttributes, BOOL bManualReset, BOOL bInitialState, LPCWSTR lpName);
extern HANDLE CreateMutexW(LPSECURITY_ATTRIBUTES lpMutexAttributes, BOOL bInitialOwner, LPCWSTR lpName);
extern DWORD GetTickCount(void);
extern ULONGLONG GetTickCount64(void);
extern void GetSystemTimeAsFileTime(LPFILETIME lpSystemTimeAsFileTime);
extern HANDLE CreateFileMappingW(HANDLE hFile, LPSECURITY_ATTRIBUTES lpFileMappingAttributes, DWORD flProtect, DWORD dwMaximumSizeHigh, DWORD dwMaximumSizeLow, LPCWSTR lpName);
extern LPVOID MapViewOfFile(HANDLE hFileMappingObject, DWORD dwDesiredAccess, DWORD dwFileOffsetHigh, DWORD dwFileOffsetLow, SIZE_T dwNumberOfBytesToMap);
extern BOOL UnmapViewOfFile(LPCVOID lpBaseAddress);
extern HLOCAL LocalAlloc(UINT uFlags, SIZE_T uBytes);
extern HLOCAL LocalFree(HLOCAL hMem);
extern LPVOID GlobalAlloc(UINT uFlags, SIZE_T dwBytes);
extern LPVOID GlobalLock(HGLOBAL hMem);
extern BOOL GlobalUnlock(HGLOBAL hMem);
extern HGLOBAL GlobalFree(HGLOBAL hMem);
extern DWORD GetEnvironmentVariableW(LPCWSTR lpName, LPWSTR lpBuffer, DWORD nSize);
extern DWORD ExpandEnvironmentStringsW(LPCWSTR lpSrc, LPWSTR lpDst, DWORD nSize);
extern DWORD GetFileSize(HANDLE hFile, LPDWORD lpFileSizeHigh);
extern DWORD SetFilePointer(HANDLE hFile, LONG lDistanceToMove, LPLONG lpDistanceToMoveHigh, DWORD dwMoveMethod);
extern BOOL DeleteFileW(LPCWSTR lpFileName);
extern BOOL CopyFileW(LPCWSTR lpExistingFileName, LPCWSTR lpNewFileName, BOOL bFailIfExists);
extern BOOL MoveFileW(LPCWSTR lpExistingFileName, LPCWSTR lpNewFileName);
extern int lstrcmpW(LPCWSTR lpString1, LPCWSTR lpString2);
extern int lstrcmpiW(LPCWSTR lpString1, LPCWSTR lpString2);
extern int lstrcmpA(LPCSTR lpString1, LPCSTR lpString2);
extern int lstrcmpiA(LPCSTR lpString1, LPCSTR lpString2);
extern int lstrlenW(LPCWSTR lpString);
extern int lstrlenA(LPCSTR lpString);
extern LPWSTR lstrcpyW(LPWSTR lpString1, LPCWSTR lpString2);
extern LPWSTR lstrcatW(LPWSTR lpString1, LPCWSTR lpString2);
extern int MultiByteToWideChar(UINT CodePage, DWORD dwFlags, LPCSTR lpMultiByteStr, int cbMultiByte, LPWSTR lpWideCharStr, int cchWideChar);
extern int WideCharToMultiByte(UINT CodePage, DWORD dwFlags, LPCWSTR lpWideCharStr, int cchWideChar, LPSTR lpMultiByteStr, int cbMultiByte, LPCSTR lpDefaultChar, LPBOOL lpUsedDefaultChar);
extern int wsprintfW(LPWSTR param1, LPCWSTR param2);
extern int wsprintfA(LPSTR param1, LPCSTR param2);
extern void OutputDebugStringW(LPCWSTR lpOutputString);
extern void OutputDebugStringA(LPCSTR lpOutputString);
extern BOOL IsDebuggerPresent(void);
extern BOOL CheckRemoteDebuggerPresent(HANDLE hProcess, LPBOOL pbDebuggerPresent);
extern HMODULE LoadLibraryExW(LPCWSTR lpLibFileName, HANDLE hFile, DWORD dwFlags);
extern DWORD GetModuleFileNameW(HMODULE hModule, LPWSTR lpFilename, DWORD nSize);
extern HWND GetForegroundWindow(void);
extern HWND GetActiveWindow(void);
extern HWND GetDesktopWindow(void);
extern HWND FindWindowW(LPCWSTR lpClassName, LPCWSTR lpWindowName);
extern HWND FindWindowExW(HWND hWndParent, HWND hWndChildAfter, LPCWSTR lpszClass, LPCWSTR lpszWindow);
extern DWORD GetWindowThreadProcessId(HWND hWnd, LPDWORD lpdwProcessId);
extern BOOL EnumWindows(WNDENUMPROC lpEnumFunc, LPARAM lParam);
extern BOOL EnumChildWindows(HWND hWndParent, WNDENUMPROC lpEnumFunc, LPARAM lParam);
extern int GetWindowTextW(HWND hWnd, LPWSTR lpString, int nMaxCount);
extern int GetClassNameW(HWND hWnd, LPWSTR lpClassName, int nMaxCount);
extern BOOL GetWindowRect(HWND hWnd, LPRECT lpRect);
extern BOOL GetClientRect(HWND hWnd, LPRECT lpRect);
extern LONG_PTR GetWindowLongPtrW(HWND hWnd, int nIndex);
extern LONG_PTR SetWindowLongPtrW(HWND hWnd, int nIndex, LONG_PTR dwNewLong);
extern LONG GetWindowLongW(HWND hWnd, int nIndex);
extern LONG SetWindowLongW(HWND hWnd, int nIndex, LONG dwNewLong);
extern BOOL SetWindowPos(HWND hWnd, HWND hWndInsertAfter, int X, int Y, int cx, int cy, UINT uFlags);
extern BOOL MoveWindow(HWND hWnd, int X, int Y, int nWidth, int nHeight, BOOL bRepaint);
extern BOOL ShowWindow(HWND hWnd, int nCmdShow);
extern BOOL UpdateWindow(HWND hWnd);
extern BOOL IsIconic(HWND hWnd);
extern BOOL IsZoomed(HWND hWnd);
extern BOOL IsWindow(HWND hWnd);
extern BOOL IsWindowVisible(HWND hWnd);
extern BOOL SetForegroundWindow(HWND hWnd);
extern HWND SetActiveWindow(HWND hWnd);
extern HWND SetFocus(HWND hWnd);
extern BOOL BringWindowToTop(HWND hWnd);
extern HWND SetParent(HWND hWndChild, HWND hWndNewParent);
extern BOOL SetLayeredWindowAttributes(HWND hwnd, DWORD crKey, BYTE bAlpha, DWORD dwFlags);
extern HHOOK SetWindowsHookExW(int idHook, HOOKPROC lpfn, HINSTANCE hmod, DWORD dwThreadId);
extern BOOL UnhookWindowsHookEx(HHOOK hhk);
extern LRESULT CallNextHookEx(HHOOK hhk, int nCode, WPARAM wParam, LPARAM lParam);
extern void PostQuitMessage(int nExitCode);
extern BOOL PostMessageW(HWND hWnd, UINT Msg, WPARAM wParam, LPARAM lParam);
extern LRESULT SendMessageW(HWND hWnd, UINT Msg, WPARAM wParam, LPARAM lParam);
extern BOOL PeekMessageW(LPMSG lpMsg, HWND hWnd, UINT wMsgFilterMin, UINT wMsgFilterMax, UINT wRemoveMsg);
extern BOOL GetMessageW(LPMSG lpMsg, HWND hWnd, UINT wMsgFilterMin, UINT wMsgFilterMax);
extern BOOL TranslateMessage(const MSG *lpMsg);
extern LRESULT DispatchMessageW(const MSG *lpMsg);
extern DWORD MsgWaitForMultipleObjectsEx(DWORD nCount, LPHANDLE pHandles, DWORD dwMilliseconds, DWORD dwWakeMask, DWORD dwFlags);
extern int MessageBoxW(HWND hWnd, LPCWSTR lpText, LPCWSTR lpCaption, UINT uType);
extern HICON LoadIconW(HINSTANCE hInstance, LPCWSTR lpIconName);
extern HCURSOR LoadCursorW(HINSTANCE hInstance, LPCWSTR lpCursorName);
extern HRESULT DwmSetWindowAttribute(HWND hwnd, DWORD dwAttribute, LPCVOID pvAttribute, DWORD cbAttribute);
extern HRESULT DwmGetWindowAttribute(HWND hwnd, DWORD dwAttribute, PVOID pvAttribute, DWORD cbAttribute);
extern HRESULT DwmExtendFrameIntoClientArea(HWND hWnd, const MARGINS *pMarInset);
extern HRESULT DwmEnableBlurBehindWindow(HWND hWnd, LPCVOID pBlurBehind);
extern LONG RegOpenKeyExW(HKEY hKey, LPCWSTR lpSubKey, DWORD ulOptions, DWORD samDesired, PHKEY phkResult);
extern LONG RegCreateKeyExW(HKEY hKey, LPCWSTR lpSubKey, DWORD Reserved, LPWSTR lpClass, DWORD dwOptions, DWORD samDesired, LPSECURITY_ATTRIBUTES lpSecurityAttributes, PHKEY phkResult, LPDWORD lpdwDisposition);
extern LONG RegSetValueExW(HKEY hKey, LPCWSTR lpValueName, DWORD Reserved, DWORD dwType, LPBYTE lpData, DWORD cbData);
extern LONG RegQueryValueExW(HKEY hKey, LPCWSTR lpValueName, LPDWORD lpReserved, LPDWORD lpType, LPBYTE lpData, LPDWORD lpcbData);
extern LONG RegDeleteValueW(HKEY hKey, LPCWSTR lpValueName);
extern LONG RegCloseKey(HKEY hKey);
extern int WSAStartup(WORD wVersionRequested, LPVOID lpWSAData);
extern int WSACleanup(void);
extern SOCKET socket(int af, int type, int protocol);
extern int connect(SOCKET s, LPCVOID name, int namelen);
extern int send(SOCKET s, LPCSTR buf, int len, int flags);
extern int recv(SOCKET s, LPSTR buf, int len, int flags);
extern int closesocket(SOCKET s);
extern HINTERNET InternetOpenW(LPCWSTR lpszAgent, DWORD dwAccessType, LPCWSTR lpszProxy, LPCWSTR lpszProxyBypass, DWORD dwFlags);
extern HINTERNET InternetOpenUrlW(HINTERNET hInternet, LPCWSTR lpszUrl, LPCWSTR lpszHeaders, DWORD dwHeadersLength, DWORD dwFlags, DWORD_PTR dwContext);
extern HINTERNET InternetConnectW(HINTERNET hInternet, LPCWSTR lpszServerName, WORD nServerPort, LPCWSTR lpszUserName, LPCWSTR lpszPassword, DWORD dwService, DWORD dwFlags, DWORD_PTR dwContext);
extern BOOL InternetReadFile(HINTERNET hFile, LPVOID lpBuffer, DWORD dwNumberOfBytesToRead, LPDWORD lpdwNumberOfBytesRead);
extern BOOL InternetCloseHandle(HINTERNET hInternet);
extern HINSTANCE ShellExecuteW(HWND hwnd, LPCWSTR lpOperation, LPCWSTR lpFile, LPCWSTR lpParameters, LPCWSTR lpDirectory, int nShowCmd);
extern void CoUninitialize(void);
extern HRESULT CoInitializeEx(LPVOID pvReserved, DWORD dwCoInit);
extern HRESULT CoCreateInstance(LPCVOID rclsid, LPVOID pUnkOuter, DWORD dwClsContext, LPCVOID riid, LPVOID ppv);
extern LPVOID SysAllocString(LPCWSTR psz);
extern void SysFreeString(LPVOID bstrString);
`;

export function win32Prototypes(is64: boolean): string {
  return pointerSizedTypedefs(is64) + WIN32_TYPES + WIN32_FUNCS;
}
